export default __webpack_public_path__ + "static/media/fl1.554266db.png";